export enum RECEIVING_COLUMN_NAME {
  PARCEL_CENTER_LOCATION_NAME = "parcelCenterLocationName",
  CLIENT_NAME = "clientName",
  FDP_COMPANY_NAME = "fdpCompanyName",
  PACKAGE_FDP_ID = "packageFdpId",
  PACKAGE_TRACKING_NUMBER = "packageTrackingNumber",
  ARRIVAL_DATE = "arrivalDate",
  PACKAGE_DELIVERY_DATE = "packageDeliveryDate",
  PACKAGE_WORK_AREA = "packageWorkArea",
  PACKAGE_SID = "packageSid",
  PACKAGE_STATUS = "packageStatus",
}

export enum RECEIVING_LABEL_NAME {
  PARCEL_CENTER_LOCATION_NAME = "Parcel Center",
  CLIENT_NAME = "Client",
  FDP_COMPANY_NAME = "FDP",
  PACKAGE_FDP_ID = "FDP ID",
  PACKAGE_TRACKING_NUMBER = "Package Tracking Number",
  ARRIVAL_DATE = "Arrival Date",
  PACKAGE_DELIVERY_DATE = "Scheduled Delivery Date",
  PACKAGE_WORK_AREA = "Work Area",
  PACKAGE_SID = "SID",
  PACKAGE_STATUS = "Status",
}

export const RECEIVING_FILTER_COLUMN_OPTIONS = [
  {
    label: RECEIVING_LABEL_NAME.PARCEL_CENTER_LOCATION_NAME,
    value: RECEIVING_COLUMN_NAME.PARCEL_CENTER_LOCATION_NAME,
  },
  {
    label: RECEIVING_LABEL_NAME.CLIENT_NAME,
    value: RECEIVING_COLUMN_NAME.CLIENT_NAME,
  },
  {
    label: RECEIVING_LABEL_NAME.FDP_COMPANY_NAME,
    value: RECEIVING_COLUMN_NAME.FDP_COMPANY_NAME,
  },
  {
    label: RECEIVING_LABEL_NAME.PACKAGE_STATUS,
    value: RECEIVING_COLUMN_NAME.PACKAGE_STATUS,
  },
  {
    label: RECEIVING_LABEL_NAME.ARRIVAL_DATE,
    value: RECEIVING_COLUMN_NAME.ARRIVAL_DATE,
  },
  {
    label: RECEIVING_LABEL_NAME.PACKAGE_DELIVERY_DATE,
    value: RECEIVING_COLUMN_NAME.PACKAGE_DELIVERY_DATE,
  },
  {
    label: RECEIVING_LABEL_NAME.PACKAGE_WORK_AREA,
    value: RECEIVING_COLUMN_NAME.PACKAGE_WORK_AREA,
  },
  {
    label: RECEIVING_LABEL_NAME.PACKAGE_SID,
    value: RECEIVING_COLUMN_NAME.PACKAGE_SID,
  },
];

export function isDeliveryToday(d: string) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);

  var scheduleDate = new Date(d);
  scheduleDate.setHours(0, 0, 0, 0);

  if (String(today) === String(scheduleDate)) {
    return true;
  } else {
    return false;
  }
}
